import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { EstadoCivil } from '@shared/models';
import { ResponseWrapper } from '@shared';
import { environment } from '@env';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_ESTADO_CIVIL = '/estado-civil';

@Injectable({
  providedIn: 'root',
})
export class EstadoCivilService {
  private readonly API_URL_ESTADO_CIVIL = API_URL + ENDPOINT_ESTADO_CIVIL;
  private http = inject(HttpClient);

  listarEstadoCivil(): Observable<EstadoCivil[]> {
    return this.http.get<ResponseWrapper<EstadoCivil[]>>(this.API_URL_ESTADO_CIVIL).pipe(
      map((res) => {
        return res.data;
      }),
    );
  }
}
